module.exports = __webpack_public_path__ + "img/8.3f5f5f21.jpg";